/* Tradução
   ========================================================================== */

/**
 * É obrigatório fornecer um objeto com todas as propriedades
 * https://unpkg.com/d3-time-format/locale/pt-BR.json
 */

const locale = d3.timeFormatLocale({
  dateTime: '%A, %e de %B de %Y. %X',
  date: '%d/%m/%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ],
  shortDays: [
    'Dom',
    'Seg',
    'Ter',
    'Qua',
    'Qui',
    'Sex',
    'Sáb',
  ],
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  shortMonths: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
});

/* Formatação
   ========================================================================== */

/**
 * Traduz e formata datas
 *   mês: abreviada
 *   ano: completa
 */

const formatDate = {
  month: locale.format('%b'),
  year: locale.format('%Y'),
}

/* Margens
   ========================================================================== */

const margin = {
  top: 5,
  right: 30,
  bottom: 5,
  left: 30,
};

/* Tamanho
   ========================================================================== */

const maxContainerWidth = 960;
const maxCanvasWidth = 800;
const maxGutterWidth = (maxContainerWidth - maxCanvasWidth) / 2;

const calculateCanvasWidth = () => {
  if (window.innerWidth >= maxContainerWidth) {
    return maxCanvasWidth;
  }

  return window.innerWidth;
}

const calculateGutterWidth = () => {
  if (window.innerWidth >= maxContainerWidth) {
    return maxGutterWidth;
  }

  return 0;
}

const size = {
  width: calculateCanvasWidth() - margin.left - margin.right,
  height: 320 - margin.top - margin.bottom,
};

/* Escalas
   ========================================================================== */

/**
 * Define o intervalo de tempo em anos
 */

const period = { min: 1872, max: 2018 };

const parseDate = d3.timeParse('%Y%m%d');

/**
 * Não define o domínio propositalmente, pois este irá variar
 */

const x = d3.scaleTime()
  .range([0, size.width]);

/**
 * O elo mais alto registrado foi o da Alemanha em 2014 com 501 pontos
 */

const y = d3.scaleLinear()
  .domain([-500, 500 + margin.top])
  .range([size.height, 0]);

/* Eixos
   ========================================================================== */

const xAxis = d3.axisBottom()
  .scale(x)
  .tickFormat((date) => {
    if (window.innerWidth >= breakpoints.xs.plus) {
      return formatDate.month(date);
    }

    return formatDate.month(date).charAt(0);
  })
  .tickSize(-(size.height + margin.top + margin.bottom));

const yAxis = d3.axisLeft()
  .scale(y)
  .tickSize(3);

/* Gráfico
   ========================================================================== */

/**
 * Define array de contexto de canvas
 */

const contexts = [];

const years = d3.select('.years__swiper-container .swiper-wrapper');
const graphic = d3.select('.graphic__swiper-container .swiper-wrapper');

for (let year = period.min; year <= period.max; year++) {
  /**
   * Define domínio do eixo X entre o primeiro e último dia do ano
   */

  x.domain([new Date(year, 0, 1), new Date(year, 11, 31)]);

  /**
   * Adiciona slide no Swiper do gráfico
   */

  let slide = years.append('div')
    .classed('swiper-slide', true)
    .text(year);

  slide = graphic.append('div')
    .classed('swiper-slide', true);

  let canvas = slide.append('canvas')
    .classed('canvas', true)
    .attr('width', size.width)
    .attr('height', size.height)
    .attr('data-year', year);

  contexts.push(canvas.node().getContext('2d'));

  /**
   * Redefine variável canvas
   */

  canvas = slide.append('svg')
    .classed('canvas', true)
    .attr('xmlns', 'http://www.w3.org/2000/svg')
    .attr('width', size.width + margin.left + margin.right)
    .attr('height', size.height + margin.top + margin.bottom)
    .attr('viewBox', `0 0 ${size.width + margin.left + margin.right} ${size.height + margin.top + margin.bottom}`)
    .attr('data-year', year);

  const artboard = canvas.append('g')
    .classed('artboard', true)
    .attr('transform', `translate(${margin.left}, ${margin.top})`);

  /**
   * Desenha períodos das copas
   */

   if (Object.prototype.hasOwnProperty.call(cups, year)) {
     const cup = cups[year];

     const opening = parseDate(cup[0]);
     const closing = parseDate(cup[1]);

     d3.select(`[data-year="${year}"] .artboard`).append('rect')
       .classed('cup', true)
       .attr('x', x(opening))
       .attr('y', 0)
       .attr('width', x(closing) - x(opening))
       .attr('height', size.height)
       .style('fill', 'url(#linear-gradient-cup)');
   }

  /**
   * Desenha eixo X
   */

  const gX = artboard.append('g')
    .classed('axis x', true)
    .attr('transform', `translate(0, ${size.height + margin.top})`)
    .call(xAxis)
      .selectAll('text')
        .attr('x', (calculateCanvasWidth() - margin.left - margin.right) / 24)
        .attr('y', -12);
}

/**
 * Desenha eixo Y
 */

const gY = d3.select('.graphic__swiper-container').append('div')
  .classed('axis-y-wrapper', true)
  .style('transform', `translateX(${calculateGutterWidth()}px)`)
  .append('svg').classed('canvas', true)
    .attr('xmlns', 'http://www.w3.org/2000/svg')
    .attr('width', 32)
    .attr('height', size.height + margin.top + margin.bottom)
    .attr('viewBox', `0 0 32 ${size.height + margin.top + margin.bottom}`)
      .append('g').classed('axis y', true)
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        .call(yAxis);

/* Swiper
   ========================================================================== */

const yearsSwiper = new Swiper('.years__swiper-container', {
  speed: 1000,
  slidesPerView: 15,
  centeredSlides: true,
  slidesOffsetBefore: -20,
  breakpoints: {
    [breakpoints.xs.plus]: {
      slidesPerView: 7,
    },
    [breakpoints.sm.mini]: {
      slidesPerView: 9,
    },
    [breakpoints.sm.base]: {
      slidesPerView: 11,
    },
  }
});

const graphicSwiper = new Swiper('.graphic__swiper-container', {
  speed: 1000,
  spaceBetween: -(margin.left + margin.right + 2 * calculateGutterWidth()),
  slidesOffsetBefore: calculateGutterWidth(),
  slidesOffsetAfter: -calculateGutterWidth(),
  allowTouchMove: false,
});

graphicSwiper.on('slideChangeTransitionEnd', () => {
  console.log('swiped');
});

document.querySelectorAll('.fade').forEach((fade) => {
  fade.style.transform = `scaleX(${(calculateGutterWidth() + margin.left) / 10})`;
});

/* Linhas
   ========================================================================== */

let rawData;

d3.csv('data/elo.csv', (d) => {
  const parseDate = d3.timeParse('%Y%m%d');

  return {
    match: +d.match,
    date: parseDate(d.date),
    team: d.team,
    elo: +d.elo,
  }
}).then((data) => {
  rawData = data;

  const nested = d3.nest()
    .key(d => d.date.getFullYear())
    .key(d => d.team)
    .entries(data);

    nested.forEach((element) => {

    const year = +element.key;

    x.domain([new Date(year, 0, 1), new Date(year, 11, 31)]);

    const teams = element.values;

    teams.forEach((element) => {
      const team = element.key;
      const matches = element.values;

      const context = contexts[year - period.min];

      const line = d3.line()
        .x(d => x(d.date))
        .y(d => y(d.elo))
        .curve(d3.curveStepAfter)
        .context(context);

      context.beginPath();
      line(matches);
      context.lineWidth = 0.2;
      context.strokeStyle = '#777';
      context.stroke();

      // Adiciona linhas no SVG
      switch (team) {
        case 'SCO':
        case 'ENG':
        case 'WAL':
        case 'EIR':
        case 'USA':
        case 'CAN':
        case 'URU':
        case 'ARG':
        case 'HUN':
        case 'AUT':
        case 'FRA':
        case 'BEL':
        case 'SUI':
        case 'HOL':
        case 'GER':
        case 'SWE':
        case 'DEN':
        case 'FIN':
        case 'BRA':
        case 'CHI':
        case 'NOR':
        case 'ESP':
        case 'TCH':
        case 'YUG':
        case 'EGY':
        case 'ITA':
        case 'PER':
        case 'MEX':
        case 'ROM':
        case 'POL':
        case 'BOL':
        case 'ECU':
        case 'PAR':
        case 'KOR':
        case 'URS':
        case 'BUL':
        case 'POR':
        case 'DDR':
        case 'NZL':
        case 'CMR':
        case 'ANG':
        case 'SEN':
        case 'IRL':
        case 'JPN':
        case 'QAT':
        case 'COL':
        case 'RUS':
        case 'NGA':
        case 'GRE':
        case 'CRO':
        case 'JAM':
        case 'MAR':
        case 'CZE':
        case 'AUS':
        case 'MAS':
        case 'TUR':
        case 'CHN':
        case 'CRC':
        case 'HON':
        case 'SRB':
        case 'VEN':
        case 'HAI':
        case 'CUB':
          const line = d3.line()
            .x(d => x(d.date))
            .y(d => y(d.elo))
            .curve(d3.curveStepAfter);

          d3.select(`[data-year="${year}"] .artboard`)
            .datum(matches).append('path')
              .classed(`line line-${team}`, true)
              .attr('d', line);

          break;
        default:
      }
    });
  });

  matches.forEach((data) => {
    const parseDate = d3.timeParse('%Y%m%d');

    const match = {
      id: data[0],
      year: +data[1].substr(0, 4),
      date: parseDate(data[1]),
      team1: {
        name: data[2][0],
        goals: data[2][1],
        elo: data[2][2],
      },
      team2: {
        name: data[3][0],
        goals: data[3][1],
        elo: data[3][2],
      },
    };

    x.domain([new Date(match.year, 0, 1), new Date(match.year, 11, 31)]);

    d3.select(`[data-year="${match.year}"] .artboard`).append('circle')
      .classed(`point point-${match.team1}`, true)
      .attr('cx', x(match.date))
      .attr('cy', y(match.team1.elo))
      .attr('r', 3)
      .attr('data-match', match.id)
      .attr('data-team', match.team1);

    d3.select(`[data-year="${match.year}"] .artboard`).append('circle')
      .classed(`point point-${match.team2}`, true)
      .attr('cx', x(match.date))
      .attr('cy', y(match.team2.elo))
      .attr('r', 3)
      .attr('data-match', match.id)
      .attr('data-team', match.team2);
  });
});

/* Métodos
   ========================================================================== */

const myGraphic = {
  typeof: 'Graphic',
  currentYear: period.min,

  /**
   * Desloca o gráfico para um dado ano
   * @param {integer} year - ano para o qual se quer que o gráfico desloque
   * @param {integer} speed - velocidade da transição
   * @return {integer} ano para o qual o gráfico foi deslocado
   */

  slideToYear(params = {}) {
    const {
      year,
      speed,
    } = params;

    const firstYear = period.min;

    console.log('Desloca: ', year);

    yearsSwiper.slideTo(year - firstYear, speed);
    graphicSwiper.slideTo(year - firstYear, speed);

    this.currentYear = year;

    return this.currentYear;
  },


  /**
   * Destaca linhas das seleções fornecidas
   * @param {strings[]} teams - array de identificadores de seleção
   * @param {boolean} flag - indica se deve acender ou apagar a linha
   */

  highlightTeams(params = {}) {
    const {
      teams,
      flags,
    } = params;

    teams.forEach((team, index) => {
      console.log(flags[index] ? 'Acende: ' : 'Apaga: ', team);
      d3.selectAll(`.line-${team}`).classed('is-active', flags[index]);
    });
  },

  highlightMatch(params = {}) {
    const {
      match,
      flag = true,
    } = params;

    console.log(flag ? 'Acende: ' : 'Apaga: ', match);
    d3.selectAll(`[data-match="${match}"]`).classed('is-active', flag);
  },
}
